<template>
  <div class="footer">
    <div>
      <a href="https://www.vhall.com/about" target="_blank" rel="noopener noreferrer">
        {{ $t('lang.k_053001') }}
        <em>｜</em>
      </a>
      <a
        href="https://www.vhall.com/page-664.html"
        target="_blank"
        rel="noopener noreferrer"
        v-if="$route.path == '/login'"
      >
        {{ $t('lang.k_053002') }}
        <em>｜</em>
      </a>
      <a
        href="https://www.vhall.com/blog/"
        target="_blank"
        rel="noopener noreferrer"
        v-if="$route.path == '/register' || $route.path == '/forgetPassword'"
      >
        {{ $t('lang.k_053003') }}
        <em>｜</em>
      </a>
      <a
        href="https://www.vhall.com/"
        target="_blank"
        rel="noopener noreferrer"
        v-if="$route.path == '/login'"
      >
        {{ $t('lang.k_053004') }}
        <em>｜</em>
      </a>
      <a
        href="https://www.vhall.com/"
        target="_blank"
        rel="noopener noreferrer"
        v-if="$route.path == '/register' || $route.path == '/forgetPassword'"
      >
        {{ $t('lang.k_053005') }}
        <em>｜</em>
      </a>
      <a href="https://www.vhall.com/" target="_blank" rel="noopener noreferrer">
        {{ $t('lang.k_053006') }}
        <em>｜</em>
      </a>
    </div>
    <div class="copy-right">
      京ICP备{{ isPls ? '13004264号-15' : '10024636号-4' }}
      京公网安备11010502008915 © Vhall 2021.All Rights Reserved.
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Footer',
    data() {
      return {
        isPls: process.env.VUE_APP_API_ENV.includes('pls')
      };
    }
  };
</script>
<style lang="less" scoped>
  .footer {
    text-align: center;
    font-weight: 100;
    font-size: 12px;
    line-height: 18px;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-bottom: 30px;
  }
  .footer a {
    color: #cccccc;
    em {
      font-style: normal;
    }
    &:hover {
      color: #1a1a1a;
      em {
        color: #cccccc;
      }
    }
  }
  .copy-right {
    color: #cccccc;
    margin-top: 8px;
  }
</style>
